//EXTERNAL
import React, { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
//COMPONENTS
// import Article from "../../../components/Article";
import Header from "../../../components/Header"
// import Post from "../../../components/Post";
import AdSlot from "../../../components/AdSlot"
import DigitalTrendsArticle from "../../../components/Article/DigitalTrends"
//ASSETS
import "./DigitalTrends.css"
import DigitalTrendsLogo from "../../../assets/digitaltrends-logo.png"
//FUNCTIONS

export default function DigitalTrends({ isDesktop }) {
  const studioV1Bucket = "https://picnic-studio-production-creativesbucket-7202zhypcuax.s3-eu-west-1.amazonaws.com/public"
  const studioV2Bucket = "https://studio-creatives-prod.s3-eu-west-2.amazonaws.com/public"

  const location = useLocation()
  const pathname = location.pathname.split("/")
  let origin = pathname[1]
  let [format, setFormat] = useState(pathname[2])
  let [teamId, setTeamId] = useState(pathname[3])
  let [creativeId, setCreativeId] = useState(pathname[4])
  const [adSlotWidth, setAdSlotWidth] = useState(null)
  const [adSlotHeight, setAdSlotHeight] = useState(null)

  useEffect(() => {
    setSizes()
  }, [])

  function setSizes() {
    if (format === "post") {
      setAdSlotHeight(410)
      setAdSlotWidth(320)
    }
    if (format === "story") {
      setAdSlotHeight(480)
      setAdSlotWidth(320)
    }
    if (format === "j5tj") {
      // preview.picnic-media.com/studio/j5tj/320x480/53405393-6a85-4441-93bf-f362ffa6353f
      setFormat(pathname[3])
      setTeamId(pathname[2])
      setAdSlotWidth(pathname[3].split("x")[0])
      setAdSlotHeight(pathname[3].split("x")[1])
    }
    // else {
    //   setAdSlotWidth(format.split("x")[0]);
    //   setAdSlotHeight(format.split("x")[1]);
    // }
  }

  function buildAdSlot() {
    return (
      <>
        {adSlotWidth !== null ? (
          <>
            <AdSlot path={buildPath()} id={creativeId} width={adSlotWidth} height={adSlotHeight} />
          </>
        ) : null}
      </>
    )
  }

  function buildPath() {
    if (origin === "studio") return `${studioV1Bucket}/${teamId}/${creativeId}/index.html`
    if (origin === "v2") return `${studioV2Bucket}/${teamId}/${creativeId}/index.min.html`
  }

  return (
    <div id="article-container-digitaltrends">
      {isDesktop ? <Header Logo={DigitalTrendsLogo} /> : null}
      <DigitalTrendsArticle isDesktop={isDesktop} format={buildAdSlot()} />
    </div>
  )
}
